import React, { Component } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../TextField/TextField';
import { isEmpty } from '../FormElement/FormElementUtils';
import {isValidPayPalPasswordFormat} from './PasswordUtils';

const LOCALE_PREFIX = 'components/Password/password';

export class Password extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        showTickMark:PropTypes.bool
    };

    render() {
        const { intl, showTickMark } = this.props;

        return (
            <div id="password-label">
                <div className="vx_col-md-6 pr-md-0">
                    <Field
                        id="password"
                        name="password"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        type="password"
                        label={intl.formatMessage({id: `${LOCALE_PREFIX}.password-label`})}
                        component={TextField}
                        pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,2}$"
                        arialabel={intl.formatMessage({id: `${LOCALE_PREFIX}.password-label`})}
                        validate={[
                            isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.password-empty`})),
                            isValidPayPalPasswordFormat(intl)
                        ]}

                    />
                </div>
                <div className="vx_col-md-6">
                    <Field
                        id="confirmPassword"
                        name="confirmPassword"
                        autoComplete="off"
                        autoCorrect="off"
                        label={intl.formatMessage({id: `${LOCALE_PREFIX}.confirmPassword-label`})}
                        autoCapitalize="off"
                        component={TextField}
                        showTickMark={showTickMark}
                        type="password"
                        arialabel={intl.formatMessage({id: `${LOCALE_PREFIX}.confirmPassword-label`})}
                        validate={[
                            isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.password-empty`}))
                        ]}
                    />
                </div>
            </div>

        );
    }
}

export default injectIntl(Password);
